// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContestLeaderboardRowStats{color:#0c6a93}.darkmode .ContestLeaderboardRowStats{color:#68b5f0}.ContestLeaderboardRowStats .statElement{margin:0 5px}.ContestLeaderboardRowStats .statData{vertical-align:middle;margin:0 3px}.darkmode .ContestLeaderboardRowStats .statData{color:#b3b3b3}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
